/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesQuotePriceListResponseDto } from '../../models/sales-quote-price-list-response-dto';

export interface QuotePriceListsControllerClearComplexities$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the quote price list.
 */
  priceListId: string;
}

export function quotePriceListsControllerClearComplexities(http: HttpClient, rootUrl: string, params: QuotePriceListsControllerClearComplexities$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuotePriceListResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, quotePriceListsControllerClearComplexities.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('priceListId', params.priceListId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesQuotePriceListResponseDto>;
    })
  );
}

quotePriceListsControllerClearComplexities.PATH = '/o2-sales/quote-price-lists/{tenant}/{priceListId}/complexities';
